import { Component, OnInit } from '@angular/core';
import { Parametro, PolizaService } from "src/app/poliza/poliza.service";
import { ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { ReportesService } from './reportes.service';
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';

declare let mostrarLoader: Function;
declare let ocultarLoader: Function;
declare let renderizarTabs: Function;
declare let convertirAMoneda: Function;
declare let renderizarDatePickers: Function;
declare let formatearFecha: Function;
declare let obtenerFecha: Function;
declare let convertirAFecha: Function;
declare let mostrarToast: Function;

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html'
})
export class ReportesComponent implements OnInit {
  campos: any[] = [];
  ramos: any[] = [];
  ramo: number;
  agencias: any[] = [];
  agencia: number;
  puntosVenta: any[] = [];
  puntoVenta: number;
  fechaDesdeDoc: string;
  fechaHastaDoc: string;
  camposReporte: any[] = [];
  reporte: any[] = [];
  encabezados: string[] = [];
  estadoCheck: boolean;

  constructor(private reportesService: ReportesService, private polizaService: PolizaService){}

  primasData: number[] = [];

  primasLabels: Label[] = [];

  primasType: ChartType = 'pie';

  primasOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top',
    },
    tooltips: {
      callbacks: {
        label: (tooltip) => `${this.primasLabels[tooltip.index]}: $${convertirAMoneda(this.primasData[tooltip.index])}`
      }
    }
  };

  primasLegend = true;

  primasColors = [{
    backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)'],
  }];


  polizasData: number[] = [];

  polizasLabels: Label[] = [];

  polizasType: ChartType = 'pie';

  polizasOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top',
    },
    tooltips: {
      callbacks: {
        label: (tooltip) => `${this.polizasLabels[tooltip.index]}: ${this.polizasData[tooltip.index]}`
      }
    }
  };

  polizasLegend = true;

  polizasColors = [{
    backgroundColor: ['rgba(255,0,0,0.3)', 'rgba(0,255,0,0.3)', 'rgba(0,0,255,0.3)'],
  }];

  async ngOnInit(){
    mostrarLoader();
    renderizarTabs();
    this.estadoCheck = false;
    const codigoAgente = sessionStorage.getItem("cod_agt");
    const codigoSucursal = sessionStorage.getItem("cod_suc");
    const cod_agt = codigoAgente ? parseInt(codigoAgente) : 0;
    const cod_suc = codigoSucursal ? parseInt(codigoSucursal) : 0;
    let primaCp = await this.reportesService.obtenerGraficaPrimas(45, cod_suc, cod_agt);
    let primaCe = await this.reportesService.obtenerGraficaPrimas(47, cod_suc, cod_agt);
    let primaRce = await this.reportesService.obtenerGraficaPrimas(74, cod_suc, cod_agt);
    this.primasData = [primaCp, primaCe, primaRce];
    this.primasLabels = [[`CP`], [`CE`], [`RCE`]];
    let polizaCp = await this.reportesService.obtenerGraficaPolizas(45, cod_suc, cod_agt);
    let polizaCe = await this.reportesService.obtenerGraficaPolizas(47, cod_suc, cod_agt);
    let polizaRce = await this.reportesService.obtenerGraficaPolizas(74, cod_suc, cod_agt);
    this.polizasData = [polizaCp, polizaCe, polizaRce];
    this.polizasLabels = [[`CP`], [`CE`], [`RCE`]];
    this.camposReporte = await this.reportesService.consultarCamposReporte();
    this.ramos = await this.polizaService.consultarRamos();
    this.ramos = [{codigo_ramo: 0, nombre: 'TODOS'},  ...this.ramos];
    await this.cargarAgenciasFiltro();
    renderizarDatePickers();
    ocultarLoader();
  }

  async cargarAgenciasFiltro(){
    const cod_suc = sessionStorage.getItem('cod_suc'),
          cod_agt = sessionStorage.getItem('cod_agt'),
          cod_tagt = sessionStorage.getItem('cod_tagt');
    let parametrosAgencias: Parametro[]=[
        {llave: "cod_sucursal", valor: cod_suc ? cod_suc : '0'},
        {llave: "cod_agente", valor: cod_agt ? cod_agt : '0' },
        {llave: "cod_tipo_agente", valor: cod_tagt ? cod_tagt : '0'}            ,
        {llave: "Cod_UsuarioSISE", valor:  sessionStorage.getItem("codusuariosise") ?  sessionStorage.getItem("codusuariosise") : '0'}
    ];

    let result=await (this.polizaService.consultarAgencias(true, parametrosAgencias));

    let agenciasResult = result.map(element => {return {codigo_agencia: element.codigoSucursal, nombre: element.nombreSucursal}});

    this.agencias = [{codigo_agencia: 0, nombre: 'TODOS'},...agenciasResult];
}

async cargarPuntosVenta(){
    const codigoUsuarioSISE = sessionStorage.getItem("codusuariosise");
    if(this.agencia){
        this.puntosVenta = await this.polizaService.consultarPuntosVenta(this.agencia, codigoUsuarioSISE) ;
        this.puntosVenta = [{codigo_punto_venta: 0, nombre: 'TODOS'},  ...this.puntosVenta];
    }
}

formatearFecha(modelo, propiedad, fecha){
    modelo[propiedad] = formatearFecha(fecha);
}

obtenerFecha(modelo, propiedad, id){
    let fecha = obtenerFecha(id);
    modelo[propiedad] = fecha.toLocaleString("es-CO", {});
}

async consultarReporte(){
    mostrarLoader();
    let fechaDesdeDoc : string = "";
    let fechaHastaDoc : string = "";
    if((this.fechaDesdeDoc == "" && this.fechaHastaDoc != "" ) || (this.fechaDesdeDoc != "" && this.fechaHastaDoc == ""))
    {
      mostrarToast("Debe seleccionar las 2 fechas obligatoriamente!");
      ocultarLoader();
      return;
    }
    if(this.fechaDesdeDoc !== "" && this.fechaHastaDoc !== "")
    {
      fechaDesdeDoc = (this.fechaDesdeDoc) ? this.fechaDesdeDoc : "";
      fechaHastaDoc = (this.fechaHastaDoc) ? this.fechaHastaDoc : "";
    }

    console.log("fechaDesde",fechaDesdeDoc);
    console.log("fechaHasta",fechaHastaDoc);

    let result: any[] = await this.reportesService.obtenerReporteDocumentos(
        this.estadoCheck,
        fechaDesdeDoc,
        fechaHastaDoc,
        (this.ramo) ? this.ramo : 0,
        (this.agencia) ? this.agencia : 0
    );

    console.log("ResultReporteDocumentos",result);

    if(result.length == 0)
        mostrarToast("La consulta no encontró coincidencias con los filtros especificados.");

    this.descargarExcel(result);

    ocultarLoader();
}

async descargarExcel(JSONreporte : any){
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(JSONreporte);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'ReporteDocumentos');

  const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
  saveAs(data, `Reporte_documentos_${new Date().toLocaleDateString("es-CO")}.xlsx`);
}

eliminarDuplicados(arr: any[]): any[] {
  const uniqueRecords = [];
  const uniqueRecordKeys = new Set();

  for (const record of arr) {
      const key = this.campos.map((campo) => record[campo.trim()]).join("-");
      if (!uniqueRecordKeys.has(key)) {
          uniqueRecordKeys.add(key);
          uniqueRecords.push(record);
      }
  }

  return uniqueRecords;
}

tableToXLSX() {
  mostrarLoader();
  console.log("ReporteTabla", this.reporte);

  // Formatear las fechas en la matriz de datos
  const formattedData = this.formatProperties(this.reporte);

  // Agregar los encabezados al inicio de la matriz de datos
  formattedData.unshift(this.encabezados);

  for (let i = 0; i < formattedData.length; i++) {
for (let j = 0; j < formattedData[i].length; j++) {
  if (typeof formattedData[i][j] === 'number') {
    formattedData[i][j] = formattedData[i][j].toString();
  }
}
}

  // Crear el libro de Excel
  const worksheet = XLSX.utils.aoa_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");

  // Escribir el archivo
  XLSX.writeFile(workbook, "Reporte_" + (new Date().toLocaleDateString("es-CO")) + ".xlsx");

  ocultarLoader();
}

tableToTxt(){
  mostrarLoader();
  console.log("ReporteTabla", this.reporte);

  // Formatear las fechas en la matriz de datos
  const formattedData = this.formatProperties(this.reporte);

  // Agregar los encabezados al inicio de la matriz de datos
  formattedData.unshift(this.encabezados);

  // Crear el libro de Excel
  const worksheet = XLSX.utils.aoa_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");

  // Escribir el archivo
  XLSX.writeFile(workbook, "Reporte_" + (new Date().toLocaleDateString("es-CO")) + ".txt");

  ocultarLoader();
}

formatDate(date: Date): string {
  const day = ('0' + date.getDate()).slice(-2);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  const hours = ('0' + ((date.getHours() + 11) % 12 + 1)).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);
  const amPM = date.getHours() >= 12 ? 'P. M.' : 'A. M.';

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${amPM}`;
}

formatProperties(data: any[][]): any[][] {
  const newData = data.map((row) => {
    return row.map((value) => {
      if (value instanceof Date) {
        return this.formatDate(value);
      }
      return value;
    });
  });

  return newData;
}
}
